$(() => { 
	const userAgent = window.navigator.userAgent;
	const msie = userAgent.indexOf('MSIE '); // IE 10 or older
	const trident = userAgent.indexOf('Trident/'); //IE 11
	if (msie != -1 || trident != -1) {
		alert("Please use Microsoft Edge or a newer web browser to view this website.");
	}
})